module.exports = __webpack_public_path__ + "img/cartoon2.fbf95e41.jpg";